export const profilePath = (user) => {
  return '#'
}
